export const CONTENT_FETCH_REQUEST = 'CONTENT_FETCH_REQUEST';
export const CONTENT_FETCH_SUCCESS = 'CONTENT_FETCH_SUCCESS';
export const CONTENT_FETCH_FAIL = 'CONTENT_FETCH_FAIL';
